/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdvancedSearchAdminResultsResponse } from './';
import {
    AdvancedSearchAdminResultsResponseFromJSON,
    AdvancedSearchAdminResultsResponseFromJSONTyped,
    AdvancedSearchAdminResultsResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdvancedSearchAdminAlgorithmsResultsResponse
 */
export interface AdvancedSearchAdminAlgorithmsResultsResponse {
    /**
     * 
     * @type {Array<AdvancedSearchAdminResultsResponse>}
     * @memberof AdvancedSearchAdminAlgorithmsResultsResponse
     */
    algorithms: Array<AdvancedSearchAdminResultsResponse>;
}

/**
 * Check if a given object implements the AdvancedSearchAdminAlgorithmsResultsResponse interface.
 */
export function instanceOfAdvancedSearchAdminAlgorithmsResultsResponse(value: object): value is AdvancedSearchAdminAlgorithmsResultsResponse {
    if (!('algorithms' in value) || value['algorithms'] === undefined) return false;
    return true;
}

export function AdvancedSearchAdminAlgorithmsResultsResponseFromJSON(json: any): AdvancedSearchAdminAlgorithmsResultsResponse {
    return AdvancedSearchAdminAlgorithmsResultsResponseFromJSONTyped(json, false);
}

export function AdvancedSearchAdminAlgorithmsResultsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchAdminAlgorithmsResultsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'algorithms': ((json['algorithms'] as Array<any>).map(AdvancedSearchAdminResultsResponseFromJSON)),
    };
}

export function AdvancedSearchAdminAlgorithmsResultsResponseToJSON(value?: AdvancedSearchAdminAlgorithmsResultsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'algorithms': ((value['algorithms'] as Array<any>).map((v) => AdvancedSearchAdminResultsResponseToJSON(v))),
    };
}

